import { render } from "./TemplateProduct.vue?vue&type=template&id=2ab52ed6"
import script from "./TemplateProduct.vue?vue&type=script&lang=js"
export * from "./TemplateProduct.vue?vue&type=script&lang=js"

import "./TemplateProduct.vue?vue&type=style&index=0&id=2ab52ed6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__